import { keyframes } from '@mui/system';

import { colors, COLORS } from '@constants/colors';

import { IHomeBarButtonStyles } from './intefaces';
import { IStyles } from '@interfaces/styles';
import { ScreenSizes } from '@interfaces';
import { useTheme } from '@mui/material';

const iconPulseKeyframe = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(255, 118, 153, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 118, 153, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 118, 153, 0);
  }
`;

export const useStyles = ({
  showPulseAnimation,
}: IHomeBarButtonStyles): IStyles => {
  const { breakpoints } = useTheme();

  return {
    root: {
      display: ['none', 'flex'],
      justifyContent: 'center',
      alignItems: 'center',
      width: 'fit-content',
      height: 'fit-content',
    },
    button: {
      padding: 1,
      borderRadius: '50%',
      boxSizing: 'border-box',
      color: showPulseAnimation ? COLORS.ERROR : colors.white,
      '& svg, & img': {
        width: 28,
        height: 28,
      },
      '& img': {
        borderRadius: '50%',
      },
      '&:hover': {
        backgroundColor: colors.black_25,
      },
      '&.Mui-disabled': {
        color: showPulseAnimation ? COLORS.ERROR : colors.grey_400,
        opacity: 0.5,
        '& path': {
          stroke: 'currentColor',
        },
      },
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        padding: '4px',
        '& svg': {
          width: 20,
          height: 20,
        },
        '& img': {
          width: 24,
          height: 24,
          margin: '-4px',
        },
      },
    },
    active: {
      backgroundColor: colors.blue_second,

      '&:hover': {
        backgroundColor: colors.blue_second,
      },
    },
    warning: {
      backgroundColor: COLORS.ERROR,
      position: 'absolute',
      borderRadius: '50%',
      padding: 2,
      width: 62,
      height: 62,
      boxSizing: 'border-box',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        width: 52,
        height: 52,
      },
    },
    pulseBox: {
      backgroundColor: COLORS.ERROR,
      animation: `${iconPulseKeyframe} 2s infinite`,
      position: 'absolute',
      borderRadius: '50%',
      padding: 2,
      width: 62,
      height: 62,
      boxSizing: 'border-box',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        width: 52,
        height: 52,
      },
    },
    tooltip: {
      color: colors.white,
      fontSize: '14px',
      fontWeight: '500',
      //backgroundColor: '#0C0B0B',
      backgroundColor: '#1A1A1A99',
      padding: '10px 16px',
      borderRadius: '16px',
    },
    arrow: {
      color: '#1A1A1A99',
    },
  };
};
